/* eslint-disable complexity */
import {
  AbstractControl,
  UntypedFormControl,
  ValidatorFn
} from '@angular/forms';
import { regexList } from './regex-list';

export function PasswordValidor(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (
    value?.match(regexList.loginPassword_rule1) &&
    (value?.match(regexList.loginPassword_rule2) || [])?.length < 4
  ) {
    return <{ [s: string]: boolean }>(<unknown>null);
  }
  return { INVALID_PASSWORD_CRD: true };
}

export function moreThan3SpecialCharacters(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control?.value?.value?.trim();

    const hasRestrictedCharacters = checkRestrictedCharacters(value);

    if (hasRestrictedCharacters) {
      return { restrictedCharacters: true };
    }

    return <{ [s: string]: boolean }>(<unknown>null);
  };
}

export function forbiddenCharacters(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control?.value?.value?.trim();

    const hasForbiddenChars = checkForbiddenChars(value);

    if (hasForbiddenChars) {
      return { forbiddenCharacters: true };
    }

    return <{ [s: string]: boolean }>(<unknown>null);
  };
}

function checkRestrictedCharacters(value: string | undefined): boolean {
  const specialCharactersCount = (value?.match(/[^a-zA-Z0-9]/g) || []).length;
  return specialCharactersCount > 3;
}

function checkForbiddenChars(value: string | undefined): boolean {
  return value ? /[@<]/.test(value) : false;
}

export function hasNumberAndLetter(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control?.value?.value?.trim();
    const hasNumber = /\d/.test(value);
    const hasLetter = /[a-zA-Z]/.test(value);

    if (!hasNumber || !hasLetter) {
      return { numbersAndLettersRequired: true };
    }

    return <{ [s: string]: boolean }>(<unknown>null);
  };
}

export function hasUpperAndLowerCase(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control?.value?.value?.trim();

    const hasUppercase = /[A-Z]/.test(value);
    const hasLowercase = /[a-z]/.test(value);

    if (!hasUppercase || !hasLowercase) {
      return { upperAndLowerCaseRequired: true };
    }

    return <{ [s: string]: boolean }>(<unknown>null);
  };
}

export function lengthValidation(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control?.value?.value?.trim();

    if (value?.length <= 7 || value?.length === undefined) {
      return { minLengthRequired: true };
    }

    if (value?.length >= 21) {
      return { maxLength: true };
    }

    return <{ [s: string]: boolean }>(<unknown>null);
  };
}

export function password_equalto_check(
  control: UntypedFormControl
): { [s: string]: boolean } | null {
  if (control.parent !== undefined) {
    const confirm_password = control?.value?.value;
    const new_password = control.parent?.get('newPassword')?.value?.value;
    if (
      (new_password?.length === 0 && confirm_password?.length === 0) ||
      new_password === confirm_password
    ) {
      return null;
    }
  }
  return { INVALID_CR_PASSWORD: true };
}
